import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';
import type { SortDir } from '../../hooks/useTableSort';

interface SortableThProps {
  label: string;
  sortKey: string;
  activeKey: string;
  dir: SortDir;
  onSort: (key: string) => void;
  className?: string;
  align?: 'right' | 'left' | 'center';
}

export function SortableTh({ label, sortKey, activeKey, dir, onSort, className = '', align = 'right' }: SortableThProps) {
  const isActive = sortKey === activeKey;
  const textAlign = align === 'right' ? 'text-right' : align === 'left' ? 'text-left' : 'text-center';

  return (
    <th
      className={`px-4 py-3 cursor-pointer select-none hover:bg-gray-100 transition-colors ${textAlign} ${className}`}
      onClick={() => onSort(sortKey)}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {isActive ? (
          dir === 'asc'
            ? <ChevronUp className="w-3.5 h-3.5 text-blue-600" />
            : <ChevronDown className="w-3.5 h-3.5 text-blue-600" />
        ) : (
          <ChevronsUpDown className="w-3.5 h-3.5 text-gray-300" />
        )}
      </span>
    </th>
  );
}
